import { render } from "./itemDetailsModal.vue?vue&type=template&id=75209166&scoped=true"
import script from "./itemDetailsModal.vue?vue&type=script&lang=js"
export * from "./itemDetailsModal.vue?vue&type=script&lang=js"

import "./itemDetailsModal.vue?vue&type=style&index=0&id=75209166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75209166"]])

export default __exports__